import React, { useEffect, useState } from 'react';
import { Form, Image, Upload, message, Spin, Progress } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import '../SurveyAnswer.less';
import { batchUploadFileApi, getAliyuncred, refreshAliyuncred } from '../../api';
import config from '../../../../config';
import dayjs from 'dayjs';
import type { UploadFile } from 'antd/es/upload/interface';

interface UploadAliyunParams {
    requestId?: string;
    uploadAddress?: string;
    uploadAuth?: string;
    videoId?: string;
}

// 校验上传文件格式
let acceptArr = [
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/pdf',
    'image/png',
    'image/jpg',
    'image/jpeg',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

// 视频上传实例
let add = null;

// 文件收集
const Images: React.FC = ({ body, id, required, optionList, num, form, notValitator }: { body?: string; required?: boolean; num?: number; id?: number; attachment?: string[]; optionList?: any; form?: any; notValitator?: any }) => {
    const [fileList, setFileList] = useState<any>([]);
    const [uploading, setUploading] = useState(false);
    const [isShowTip, setIsShowTip] = useState(false);

    const [docShowProgress, setDocShowProgress] = useState(false);
    const [docProgressPercent, setDocProgressPercent] = useState(undefined);

    // 批量上传file
    const [uploadFileList, setUploadFileList] = useState<UploadFile[]>([]);

    // 移除图片
    const onRemove = (value: any) => {
        const newFileList = fileList.filter((file: any) => file.url !== value);
        setFileList(newFileList);
        let formData = form.getFieldsValue();
        if (newFileList && newFileList.length === 0) {
            form.setFieldValue(`${id}-11`, undefined);
        }

        let timer = setTimeout(() => {
            form.setFieldValue(`${id}-11`, newFileList.length ? newFileList : undefined);
            clearTimeout(timer);
        }, 0);

        formData[`${id}-11`] = newFileList && newFileList.length ? newFileList : undefined;
        localStorage.setItem('initFormData', JSON.stringify(formData));
    };

    // 上传头像
    const upload = async (value: any) => {
        if (!Array.isArray(value)) {
            return;
        }

        if (fileList.length + value.length > 10) {
            return message.error('最多上传10个文件');
        }

        let formData = new FormData();
        value.forEach((file: any, index: number) => {
            formData.append(`files[${index}].file`, file);
            formData.append(`files[${index}].path`, `attachments/${dayjs().format('YYYYMM')}/`);
        });

        form.setFieldValue(`${id}-11`, fileList.length ? fileList : undefined);

        setDocShowProgress(true);
        let configParams = {
            onUploadProgress: (Progress: { loaded: number; total: number }) => {
                let percents: any = Math.round((Progress.loaded * 100) / Progress.total);
                setDocProgressPercent(percents); // 更新进度条
            },
        };
        const res: any = await batchUploadFileApi(formData, configParams);
        if (res && res.status_code === 200) {
            setDocShowProgress(false);
            setDocProgressPercent(undefined);

            const newData = res.data.map((url: string, index: number) => ({ name: value[index].name, url: `${config.OSS_URL_PREFIX}/${url}` }));
            const list = fileList.concat(newData);
            let formData = form.getFieldsValue();
            formData[`${id}-11`] = list;
            localStorage.setItem('initFormData', JSON.stringify(formData));
            form.setFieldValue(`${id}-11`, list);
            setFileList(list);
        } else {
            form.setFieldValue(`${id}-11`, fileList.length ? fileList : undefined);
        }
    };
    // 上传头像格式校验 - 单张校验、多张则过滤不合格图片
    const beforeUpload = (file: any, list: UploadFile[]) => {
        const isJpgOrPng =
            file.type === 'application/vnd.ms-powerpoint'
            || file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
            || file.type === 'application/msword'
            || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            || file.type === 'application/pdf'
            || file.type === 'image/png'
            || file.type === 'image/jpg'
            || file.type === 'image/jpeg'
            || file.type === 'application/vnd.ms-excel'
            || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            || file.type === 'video/mp4'
            || file.type === 'video/quicktime'
            || file.type === 'video/x-ms-wmv';

        if (list.length === 1 && !isJpgOrPng) {
            message.error('只能上传 PPT、PPTX、DOC、DOCX、PDF、PNG、JPG、XLS、XLSX、MP4、MOV、WMV 格式');

            let timer = setTimeout(() => {
                form.setFieldValue(`${id}-11`, fileList.length ? fileList : undefined);
                clearTimeout(timer);
            }, 0);

            console.log(form.getFieldsValue());
            return false;
        }
        const isLt5M = file.size / 1024 / 1024 <= 500;
        if (list.length === 1 && !isLt5M) {
            message.error('文件大小不超过500MB');

            let timer = setTimeout(() => {
                form.setFieldValue(`${id}-11`, fileList.length ? fileList : undefined);
                clearTimeout(timer);
            }, 0);
            return false;
        }

        // checkBatchFile(list);
        if (file.type === 'video/mp4' || file.type === 'video/quicktime' || file.type === 'video/x-ms-wmv') {
            uploadVideoList(file);
        } else {
            setUploadFileList(list);
        }
        return isJpgOrPng && isLt5M;
    };

    // 阿里云上传视频
    const uploadVideoList = async (file: any) => {
        add = createUploader();
        const userData = '{"Vod":{}}';

        add.addFile(file, null, null, null, userData);
        await add.startUpload();
    };

    // 阿里云视频上传实例
    const createUploader = () => {
        let uploader = new (window as any).AliyunUpload.Vod({
            timeout: 1200000,
            partSize: 1048576,
            parallel: 100,
            retryCount: 3,
            retryDuration: 2,
            region: 'cn-shanghai',
            userId: '1303984639806000',

            // 添加文件成功
            addFileSuccess: (uploadInfo: any) => {
                if (uploadInfo !== null) {
                    uploader.startUpload();
                }
            },

            // 开始上传
            onUploadstarted: async (uploadInfo: any) => {
                setDocShowProgress(true);
                if (!uploadInfo.videoId) {
                    let params = {
                        fileName: uploadInfo.file.name,
                        title: uploadInfo.file.name.substring(0, uploadInfo.file.name.lastIndexOf('.')),
                        companyCode: 'CASE',
                        mediaType: 1,
                        cateId: 14131,
                    };
                    await getAliyuncred(params).then((res: any) => {
                        if (res) {
                            let data: any = res.data;
                            let uploadAuth = data.uploadAuth;
                            let uploadAddress = data.uploadAddress;
                            let videoId = data.videoId;
                            uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, videoId);
                        }
                    });
                } else {
                    // 如果videoId有值，根据videoId刷新上传凭证
                    refreshAliyuncred({ videoId: uploadInfo.videoId }).then((res: any) => {
                        if (res) {
                            let initData = res.data;
                            let data = initData as UploadAliyunParams;
                            let uploadAuth = data.uploadAuth;
                            let uploadAddress = data.uploadAddress;
                            let videoId = data.videoId;
                            uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, videoId);
                        }
                    });
                }
            },
            // 文件上传成功
            onUploadSucceed: function (uploadInfo: any) {
                console.log(uploadInfo);
                let videoItem = {
                    name: uploadInfo.file.name,
                    videoId: uploadInfo.videoId,
                    url: uploadInfo.object,
                };
                setDocShowProgress(false);
                setDocProgressPercent(undefined);

                const list = fileList.concat([{ name: videoItem.name, url: `https://media.cn-healthcare.com/${videoItem.url}` }]);
                let formDataValue = form.getFieldsValue();
                formDataValue[`${id}-11`] = list;
                localStorage.setItem('initFormData', JSON.stringify(formDataValue));
                form.setFieldValue(`${id}-11`, list);
                setFileList(list);
            },
            // 文件上传失败
            onUploadFailed: function (uploadInfo: any, code: any, message: any) {
                message.error('上传失败');
            },
            // 取消文件上传
            onUploadCanceled: function (uploadInfo: any, code: any, message: any) {},
            // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
            onUploadProgress: function (uploadInfo: any, totalSize: any, progress: number) {
                let percent: any = Math.floor(progress * 100);
                setDocProgressPercent(percent);
            },
            // 上传凭证超时
            onUploadTokenExpired: function (uploadInfo: any) {
                // 上传大文件超时, 如果是上传方式一即根据 UploadAuth 上传时
                // 需要根据 uploadInfo.videoId 调用刷新视频上传凭证接口
                refreshAliyuncred({ videoId: uploadInfo.videoId }).then((res: any) => {
                    if (res) {
                        let initData = res.data;
                        let data = initData as UploadAliyunParams;
                        let uploadAuth = data.uploadAuth;
                        uploader.resumeUploadWithAuth(uploadAuth);
                    }
                });
            },
            // 全部文件上传结束
            onUploadEnd: function (uploadInfo: any) {
                setDocProgressPercent(undefined);
            },
        });
        return uploader;
    };

    useEffect(() => {
        const formData = localStorage.getItem('initFormData');
        console.log(formData);
        if (formData) {
            let arr = JSON.parse(formData);
            if (arr[`${id}-11`] && arr[`${id}-11`].length) {
                if (Array.isArray(arr[`${id}-11`])) {
                    setFileList(arr[`${id}-11`]);
                    form.setFieldValue(`${id}-11`, arr[`${id}-11`]);
                } else {
                    setFileList([]);
                    form.setFieldValue(`${id}-11`, null);
                }
            }
        }
    }, []);

    // 接口回显数据
    useEffect(() => {
        if (optionList && optionList.length && optionList[0].content) {
            let values = JSON.parse(optionList[0].content);
            if (Array.isArray(values)) {
                setFileList(values);
            }
        }
    }, [optionList]);

    useEffect(() => {
        if (notValitator?.indexOf(id) !== -1) {
            setIsShowTip(true);
        } else {
            setIsShowTip(false);
        }
    }, [notValitator]);

    // 批量上传 - 自动过滤大小不合格文件
    useEffect(() => {
        if (uploadFileList && uploadFileList.length) {
            if (uploadFileList.length > 1) {
                const newList = uploadFileList.filter((file: any) => file.size / 1024 / 1024 <= 50 && acceptArr.includes(file.type));
                if (newList && newList.length) {
                    form.setFieldValue(`${id}-11`, fileList.length ? fileList : undefined);
                    upload(newList);
                }
            } else {
                form.setFieldValue(`${id}-11`, fileList.length ? fileList : undefined);
                upload(uploadFileList);
            }
        }
    }, [uploadFileList]);

    return (
        <>
            <Form.Item
                name={`${id}-11`}
                rules={[{ required, message: '该题为必答题，请作答后提交。' }]}
                label={<div className="label-flex" style={{ display: 'flex' }} dangerouslySetInnerHTML={{ __html: `<span class="title-num">${num}.</span>` + `<span>${body}</span>` }}></div>}
                extra="500M以内的文件，支持格式 PPT、PPTX、DOC、DOCX、PDF、PNG、JPG、XLS、XLSX、MP4、MOV、WMV 格式"
            >
                <div className={`images-topic ${isShowTip ? 'ant-form-item-has-error' : null}`}>
                    {fileList && fileList.length >= 10 ? null : (
                        <Upload
                            disabled={docShowProgress}
                            customRequest={upload}
                            listType="picture-card"
                            fileList={[]}
                            onRemove={onRemove}
                            beforeUpload={beforeUpload}
                            // accept={acceptType}
                            maxCount={10}
                        >
                            <div>
                                <PlusOutlined />
                                <div style={{ marginTop: 8 }}>上传文件</div>
                                {/* <div>50M以内的文件，支持格式 PPT、PPTX、DOC、DOCX、PDF、PNG、JPG、XLS、XLSX 格式</div> */}
                            </div>
                        </Upload>
                    )}
                    {fileList && fileList.length
                        ? fileList.map((file: any, index: number) => (
                              <div className="images-item" key={index}>
                                  <span className="file-item">{file.name}</span>
                                  <MinusCircleOutlined onClick={() => onRemove(file.url)} />
                              </div>
                          ))
                        : null}
                    {!!uploading && (
                        <div className="images-item">
                            <Spin tip="上传中..." />
                        </div>
                    )}
                    {docShowProgress && <Progress percent={docProgressPercent} />}
                </div>
            </Form.Item>
        </>
    );
};

export default Images;
